import { render, staticRenderFns } from "./cCheckSummary.vue?vue&type=template&id=6622ef8f&scoped=true"
import script from "./cCheckSummary.vue?vue&type=script&lang=js"
export * from "./cCheckSummary.vue?vue&type=script&lang=js"
import style0 from "./cCheckSummary.vue?vue&type=style&index=0&id=6622ef8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6622ef8f",
  null
  
)

export default component.exports